import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KtLogsListingModel } from 'common/models/page-models/kt-logs/kt-logs-grid.model';
import { KtLogsModel } from 'common/models/page-models/kt-logs/kt-logs-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { KTLogsGridWidgetService } from 'common/widget/kt-logs/kt-logs.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class KtLogsGridResolver extends GridResolver<KtLogsModel, KtLogsListingModel> {
    constructor(
        protected fs: KTLogsGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}